import { styled, type Theme, type SupportedColorScheme } from '@mui/material/styles';
import { type SystemStyleObject } from '@mui/system';
import { forwardRef } from 'react';
import { imageFilters } from '@/styles';

type ImageThemedProps = {
  src: string;
  colorScheme: SupportedColorScheme;
  alt: string;
  themed?: boolean;
  disabled?: boolean;
  onError?: () => void;
  style?: SystemStyleObject<Theme>;
};

const StyledImg = styled('img')``;

/**
 * Component for showing an img inverting on the theme mode change to dark
 */
export const ImageThemed = forwardRef<HTMLImageElement, ImageThemedProps>(
  ({ src, colorScheme, alt, themed, disabled = false, style, ...other }, ref) => (
    <StyledImg
      ref={ref}
      alt={alt}
      src={src}
      sx={{
        ...style,
        ...imageFilters(colorScheme, disabled, themed),
      }}
      {...other}
    />
  ),
);
